import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";
import { createVuetify } from "vuetify";

// Midnight Editorial Theme - sophisticated, magazine-style aesthetic
export const vuetify = createVuetify({
  theme: {
    defaultTheme: "dark",
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#CC0001", // Red (overridden by API: primaryColorLight)
          "on-primary": "#FFFFFF",
          "primary-accent": "#4A22B3", // Primary accent
          secondary: "#820000", // Dark red (overridden by API: secondaryColorLight)
          "on-secondary": "#FFFFFF",
          "secondary-accent": "#b45309", // Secondary accent
          tertiary: "#B45309", // Amber dark (overridden by API: tertiaryColorLight)
          "on-tertiary": "#FFFFFF",
          "tertiary-accent": "#92400e",
          accent: "#B45309",
          error: "#DC2626", // API: errorColor
          "on-error": "#FFFFFF",
          warning: "#d97706", // API: warningColor
          "on-warning": "#000000",
          info: "#0369a1", // API: infoColor
          "on-info": "#FFFFFF",
          success: "#16a34a", // API: successColor
          "on-success": "#FFFFFF",
          background: "#fefcf9", // API: backgroundColorLight
          "on-background": "#1C1917",
          surface: "#FFFFFF",
          "surface-variant": "#F5F5F4",
          "surface-bright": "#FFFFFF",
          "on-surface": "#1C1917",
          "on-surface-variant": "#57534E",
          outline: "#78716C",
          "outline-variant": "#D6D3D1",
          "inverse-surface": "#1C1917",
          "inverse-on-surface": "#FAFAF9",
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: "#FF1A1A", // Red (overridden by API: primaryColorDark)
          "on-primary": "#FFFFFF",
          "primary-accent": "#7B3FFF", // Primary accent
          secondary: "#CC0001", // Dark red (overridden by API: secondaryColorDark)
          "on-secondary": "#FFFFFF",
          "secondary-accent": "#fbbf24", // Secondary accent
          tertiary: "#F59E0B", // Amber (overridden by API: tertiaryColorDark)
          "on-tertiary": "#0C0A09",
          "tertiary-accent": "#d97706", // Amber accent
          accent: "#F59E0B",
          error: "#ef4444", // API: errorColorDark
          "on-error": "#1C1917",
          warning: "#92400e", // API: warningColorDark
          "on-warning": "#FFFFFF",
          info: "#1e3a8a", // API: infoColorDark
          "on-info": "#FFFFFF",
          success: "#14532d", // API: successColorDark
          "on-success": "#FFFFFF",
          background: "#1a1815", // API: backgroundColorDark
          "on-background": "#FAFAF9",
          surface: "#242120", // Slightly lighter than background
          "surface-variant": "#2e2b29",
          "surface-bright": "#44403C",
          "on-surface": "#FAFAF9",
          "on-surface-variant": "#A8A29E",
          outline: "#78716C",
          "outline-variant": "#44403C",
          "inverse-surface": "#FAFAF9",
          "inverse-on-surface": "#1C1917",
        },
      },
    },
  },
  defaults: {
    // Avoid default scrollStrategy "block" on html/body (v-overlay-scroll-blocked,
    // --v-scrollbar-offset, etc.) — stacks badly with nested overlays, mobile keyboard,
    // and custom full-screen layers (e.g. CreatePostModal). Opt in per-component via
    // scroll-strategy="block" where background scroll lock is required.
    VDialog: {
      scrollStrategy: "close",
    },
    VBottomSheet: {
      scrollStrategy: "none",
    },
    VMenu: {
      scrollStrategy: "close",
    },
    VBtn: {
      variant: "flat",
      rounded: "lg",
    },
    VCard: {
      rounded: "xl",
    },
    VTextField: {
      variant: "outlined",
      density: "comfortable",
    },
    VChip: {
      rounded: "lg",
    },
  },
});
